import { render } from "./asideLine.vue?vue&type=template&id=1a745606"
import script from "./asideLine.vue?vue&type=script&lang=js"
export * from "./asideLine.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__